import { useStoryRolesAuth } from './useStoryRolesAuth';

type Options = {
    onAllowed?: (e: Event, item: StoryblokMultilink) => void;
    story?: unknown;
};

export function useLockLinkGuard(options: Options = {}) {
    const loginModalController = useModal();

    const { isAuthenticated } = useStoryRolesAuth(options.story);

    const isLocked = (item?: StoryblokMultilink | null) => Boolean(item?.story?.content?.locked);

    const guardClick = (e: Event, item: StoryblokMultilink | null): boolean => {
        if (isLocked(item) && !isAuthenticated.value) {
            e.preventDefault();
            e.stopPropagation();
            loginModalController.open();
            return false;
        }
        return true;
    };

    const guardKey = (e: KeyboardEvent, item: StoryblokMultilink | null): boolean => {
        if ((e.key === 'Enter' || e.key === ' ') && isLocked(item) && !isAuthenticated.value) {
            e.preventDefault();
            e.stopPropagation();
            loginModalController.open();
            return false;
        }
        return true;
    };

    const wrapNavigate = (navigate: (e?: Event) => void, item: StoryblokMultilink) => {
        const onClick = (e: Event) => {
            const ok = guardClick(e, item);
            if (!ok) return;
            options.onAllowed?.(e, item);
            navigate?.(e);
        };
        const onEnter = (e: KeyboardEvent) => {
            e.preventDefault();
            const ok = guardKey(e, item);
            if (!ok) return;
            options.onAllowed?.(e as unknown as Event, item);
            navigate?.(e as unknown as Event);
        };
        const onSpace = (e: KeyboardEvent) => {
            e.preventDefault();
            const ok = guardKey(e, item);
            if (!ok) return;
            options.onAllowed?.(e as unknown as Event, item);
            navigate?.(e as unknown as Event);
        };

        return { onClick, onEnter, onSpace };
    };

    return {
        isAuthenticated,
        isLocked,
        loginModalController,
        guardClick,
        guardKey,
        wrapNavigate
    };
}
